import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import Image from '../helpers/Image'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'

function RatesCalculator(props) {
  // not adding the boolean to the end output the length field 0 if there was no data.
  const right = props.rightTitle || props.linkItems?.length || false
  const stacked = props.layout === 'Single column'
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  return (
    <Section type="ratesCalculator" outerClass={componentPadding} sectionTitle={false} innerClass="px-6" {...props}>
      <div className={`flex max-lg:flex-col gap-14 ${stacked ? 'flex-wrap' : ''}`}>
        <div
          className={`${!right || stacked ? 'lg:basis-3/5 basis-full mx-auto text-center' : 'lg:left max-lg:text-center'}`}
        >
          {(props.title || props.description) && <TitleBlock {...props} />}

          {props.url && <iframe src={props.url} className="mt-4 w-full" height="684" />}
        </div>
        {right && (
          <div className={`${!right || stacked ? 'lg:basis-3/5 basis-full mx-auto' : 'lg:right'}`}>
            {props.rightTitle && (
              <div
                className={`${stacked ? 'text-center' : ''} max-lg:text-center text-2xl font-bold`}
                data-rte="true"
                dangerouslySetInnerHTML={createMarkup(props.rightTitle)}
              />
            )}
            {props.linkItems?.length
              ? props.linkItems.map((linkItem, i) => {
                  return (
                    <a
                      key={i}
                      href={linkItem.link?.url}
                      className="flex gap-3 items-center mt-4 px-6 lg:px-10 xl:px-12 py-6 md:py-6 border-2 border-gray-100 bg-gray-50 rounded-md text-xl font-bold"
                    >
                      {linkItem.linkImage && (
                        <span className={`${stacked ? 'basis-1/5 lg:basis-1/12' : 'basis-1/5'} grow-0`}>
                          <Image {...linkItem.linkImage} className="w-full h-auto mx-auto aspect-square rounded-none" />
                        </span>
                      )}
                      <span className={`${stacked ? 'basis-3/4 lg:basis-11/12' : 'basis-3/4'} shrink-0`}>
                        {linkItem.link?.name}
                      </span>
                    </a>
                  )
                })
              : null}
          </div>
        )}
      </div>
    </Section>
  )
}

export default RatesCalculator
